export default function reducer(state={
		sellers: [],
		fetching: false,
		fetched: false,
		error: false
	}, action) {

	switch (action.type) {
		case "FETCH_SELLERS": {
			return {...state, fetching: true}
		}
		case "FETCH_SELLERS_REJECTED": {
			return {...state, fetching: false, error: action.payload}
		}
		case "FETCH_SELLERS_FULFILLED": {
			return {...state, fetching: false, fetched: true, sellers: action.payload.sellers}
		}
		default: {
        	break;
		}
	}

	return state
}